import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';

import IUserOutput from '../IUser';
import EditUserData from '../EditUserData';

export const editUser = createAsyncThunk<IUserOutput, EditUserData>(
    'auth/editUser',

    async({id, ...data}) => {
        // @ts-ignore
        const response = await createHttpRequest({
            method: 'PUT',
            path: ApiUrls.USER(id),
            data,
            errorMessage: t`При изменении данных пользователя произошла ошибка!`,
        });

        return response.data;
    },
);
